<template>
  <div>
    <v-container grid-list-lg fluid>
        <v-layout row wrap>
        <v-flex lg12 md12 sm12 xs12>
            <v-layout row wrap>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-select :items="orderDateType" item-value="value" item-text="name" v-model="selectedDateType" label="Chọn ngày"></v-select>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6 pl-lg-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuStart"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedStartDateFormatted"
                                label="Từ ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuEnd"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedEndDateFormatted"
                                label="Đến ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-btn @click="filter_data(0)" color="#a77800" outlined>Lọc dữ liệu</v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12 md12 sm12 xs12>
            <v-layout row wrap>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-select :items="orderStatus" item-value="value" item-text="name" v-model="selectedStatus" label="Trạng thái cuối"></v-select>
                </v-flex>
                <v-flex lg6 md12 sm12 pr-6>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-btn @click="filter_data(1)" color="#a77800" outlined>Lọc dữ liệu</v-btn>
                </v-flex>
             </v-layout>    
        </v-flex>    
        <!-- <v-flex lg12 md12 sm12 xs12>
            <v-layout row wrap>
                <v-flex lg12 md12 sm12 xs12>
                    <highcharts :options="chartOptions"></highcharts>
                </v-flex>
            </v-layout>
        </v-flex> -->
        
        <v-flex lg12>
            <v-card class="mb-8">
                <v-toolbar flat color="blue-grey" dark>
                    <v-toolbar-title>Giảm trừ doanh thu</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-data-table :headers="loss_headers"  hide-default-footer disable-pagination :sortable="false" :items="loss_items" :loading="loading" :mobile-breakpoint="100">
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td class="text-end">{{ item.ComplainAmount | currency}}</td>
                                        <td class="text-end">{{ item.CancelAmount | currency}}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>

        <v-flex lg12>
            <v-card class="mb-8">
                <v-toolbar flat color="blue-grey" dark>
                    <v-toolbar-title>Doanh thu</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-data-table :headers="headers" hide-default-footer disable-pagination :sortable="false" :items="revenue_total" :loading="loading" :mobile-breakpoint="100">
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td class="text-end">{{ item.OrderRevenue | currency}}</td>
                                        <td class="text-end">{{ item.FeeWeightRevenue | currency}}</td>
                                        <td class="text-end">{{ item.ListedFeeWeightRevenue | currency}}</td>
                                        <td class="text-end">{{ item.OtherRevenue | currency}}</td>
                                        <td class="text-end">{{ item.PayRevenue | currency}}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>

        <v-flex lg12>
            <v-card class="mb-8">
                <v-toolbar flat color="blue-grey" dark>
                    <v-toolbar-title>Doanh thu theo nhân viên</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-data-table :headers="summary_headers" hide-default-footer disable-pagination :sortable="false" :items="staff_summary" :loading="loading" :mobile-breakpoint="100">
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td><a href="javascript:void(0)" @click="openListOrders(item.CustomerServiceID)">{{item.StaffName}}</a></td>
                                        <td class="text-end">{{ item.DiffRevenue | currency}}</td>
                                        <td class="text-end">{{ item.OrderRevenue | currency}}</td>
                                        <td class="text-end">{{ item.FeeWeightRevenue | currency}}</td>
                                        <td class="text-end">{{ item.ListedFeeWeightRevenueOrder | currency}}</td>
                                        <td class="text-end">{{ item.ListedFeeWeightRevenueDeposit | currency}}</td>
                                        <td class="text-end">{{ item.OtherRevenue | currency}}</td>
                                        <td class="text-end">{{ item.TotalRevenue | currency}}</td>
                                    </tr>
                                </template>
                                <template v-slot:body.append v-if="staff_total">
                                    <tr>
                                        <td class="font-weight-bold">TỔNG</td>
                                        <td class="font-weight-bold text-end">{{ staff_total.DiffRevenue | currency }}</td>
                                        <td class="font-weight-bold text-end">{{ staff_total.OrderRevenue | currency }}</td>
                                        <td class="font-weight-bold text-end">{{ staff_total.FeeWeightRevenue | currency }}</td>
                                        <td class="font-weight-bold text-end">{{ staff_total.ListedFeeWeightRevenueOrder | currency }}</td>
                                        <td class="font-weight-bold text-end">{{ staff_total.ListedFeeWeightRevenueDeposit | currency }}</td>
                                        <td class="font-weight-bold text-end">{{ staff_total.OtherRevenue | currency }}</td>
                                        <td class="font-weight-bold text-end">{{ staff_total.TotalRevenue | currency }}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialogDetail" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="oee-theme">
            <v-btn icon dark @click="dialogDetail = false">
            <v-icon>fa-times-circle</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>Danh sách đơn hàng</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <h5>Đơn mua hộ</h5>
            <order-list :showOnReport="true" :filterReport="filterOrder"></order-list>
            <h5>Đơn ký gửi</h5>
            <deposit-list :showOnReport="true" :filterReport="filterDeposit"></deposit-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import {Chart} from 'highcharts-vue';
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import moment from "moment"
import OrderList from "@/views/Order/OrderList";
import DepositList from "@/views/Deposit/list";
export default {
    components: {
        "order-list": OrderList,
        "deposit-list": DepositList,
    },
    data() {
        return {
            viewName: "bao-cao-doanh-thu",
            dialogDetail: false,
            filterType: 0,
            filterOrder: [],
            filterDeposit: [],
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            orderDateType: [
                {value: 1, name: 'Ngày tạo đơn'},
                {value: 2, name: 'Ngày mua hàng'},
                {value: 3, name: 'Ngày nhập kho gửi'},
                {value: 4, name: 'Ngày xuất kho gửi'},
                {value: 5, name: 'Ngày nhập kho nhận'},
                {value: 6, name: 'Ngày xuất kho nhận'},
                {value: 7, name: 'Ngày thanh toán'},
                {value: 8, name: 'Ngày hoàn thành'},
            ],
            orderStatus: configs.ORDER_STATUS,
            menuStart: false,
            menuEnd: false,
            selectedDateType: 1,
            selectedStatus: 5,
            loss_headers: [
                {
                text: "Hoàn tiền khiếu nại",
                value: "ComplainAmount",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Hoàn tiền hủy đơn",
                value: "CancelAmount",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                }
            ],
            headers: [
                {
                text: "Doanh thu mua hộ",
                value: "OrderRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu vận chuyển",
                value: "FeeWeightRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Chênh cước VCQT",
                value: "ListedFeeWeightRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu DV tăng thêm",
                value: "OtherRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu thanh toán hộ",
                value: "PayRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                }
            ],
            summary_headers: [
                {
                text: "Nhân viên",
                value: "StaffName",
                dataType: configs.DATA_TYPE["String"]
                },
                {
                text: "Chênh lệch tiền hàng",
                value: "DiffRevenue",
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu mua hộ",
                value: "OrderRevenue",
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu vận chuyển",
                value: "FeeWeightRevenue",
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Chênh cước VCQT order",
                value: "ListedFeeWeightRevenueOrder",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Chênh cước VCQT ký gửi",
                value: "ListedFeeWeightRevenueDeposit",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu DV tăng thêm",
                value: "OtherRevenue",
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Tổng doanh thu",
                value: "TotalRevenue",
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                }
            ],
        };
    },
    computed: {
        ...mapState({
            loss_items: state => state.report.orderRevenueV2.data.loss_items,
            rev_items: state => state.report.orderRevenueV2.data.rev_items,
            staff_summary: state => state.report.orderRevenueV2.summary,
            loading: state => state.report.loading
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        revenue_total() {
            var ret = {
                'OrderRevenue': _.sumBy(this.rev_items, 'OrderRevenue'),
                'FeeWeightRevenue': _.sumBy(this.rev_items, 'FeeWeightRevenue'),
                'ListedFeeWeightRevenue': _.sumBy(this.rev_items, 'ListedFeeWeightRevenue'),
                'OtherRevenue': _.sumBy(this.rev_items, 'OtherRevenue'),
                'PayRevenue': _.sumBy(this.rev_items, 'PayRevenue')
            };
            return [ret];
        },
        staff_total() {
            var ret = {
                'DiffRevenue': _.sumBy(this.staff_summary, 'DiffRevenue'),
                'FeeWeightRevenue': _.sumBy(this.staff_summary, 'FeeWeightRevenue'),
                'ListedFeeWeightRevenueOrder': _.sumBy(this.staff_summary, 'ListedFeeWeightRevenueOrder'),
                'ListedFeeWeightRevenueDeposit': _.sumBy(this.staff_summary, 'ListedFeeWeightRevenueDeposit'),
                'OrderRevenue': _.sumBy(this.staff_summary, 'OrderRevenue'),
                'OtherRevenue': _.sumBy(this.staff_summary, 'OtherRevenue'),
                'TotalRevenue': _.sumBy(this.staff_summary, 'TotalRevenue'),
            };
            return ret;
        },
        // chartOptions() {
        //     var dataChart =  _.sortBy(this.items,'ReportMonth');
        //     var ret = {
        //         chart: { type: 'line' },
        //         title: { text: 'Doanh thu' },
        //         credits: { enabled: false },
        //         tooltip: {shared: true},
        //         xAxis: {
        //             categories: _.map(dataChart, function(x) {return x.ReportMonth.toString().replace(/(\d{4})(\d{2})/, "$2-$1")})
        //         },
        //         yAxis: {
        //             title: {
        //                 text: 'Tổng tiền (VNĐ)'
        //             }
        //         },
        //         plotOptions: {
        //             line: {
        //                 dataLabels: {
        //                     enabled: true
        //                 }
        //             }
        //         },
        //         series: [
        //             { name: 'Mua hộ', data: _.map(dataChart, 'OrderRevenue') },
        //             { name: 'Ký gửi', data: _.map(dataChart, 'DepositRevenue') },
        //             { name: 'TT hộ', data: _.map(dataChart, 'PayRevenue') },
        //             { name: 'Hoàn khách', data: _.map(dataChart, 'ComplainAmount') },
        //             { name: 'Tổng giao dịch', data: _.map(dataChart, 'TotalRevenue') },
        //         ]
        //     };

        //     return ret;
        // }
    },
    methods: {
        filter_data: function (type = 0) {
            this.filterType = type;
            var param = {
                filterType: type,
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
                orderStatus: this.selectedStatus,
                dateType: this.selectedDateType
            };
            this.$store.dispatch("report/getOrderRevenueV2Report", param);
        },
        buildFilter(csid, orderType = 0) {
            let filter = [];
            if(orderType == 0) {
                filter.push({
                    column: ["CustomerServiceID","BuyerID"],
                    value: csid,
                    condition: "equal_or",
                });
            }
            else {
                filter.push({
                    column: "CustomerServiceID",
                    value: csid,
                    condition: "equal",
                });
            }
            if(this.filterType == 1) {
                filter.push({
                    column: "Status",
                    value: this.selectedStatus,
                    condition: "equal",
                });
            }
            else { 
                let startTime = moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT);
                let endTime = moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT);
                filter.push({
                    column: "Status",
                    value: 1,
                    condition: "does_not_equal",
                });
                switch (this.selectedDateType) {
                    case 1:
                        filter.push({
                            column: "CreatedDate",
                            value: startTime,
                            condition: "d_greater_than_or_equal",
                        });
                        filter.push({
                            column: "CreatedDate",
                            value: endTime,
                            condition: "d_less_than_or_equal",
                        });
                        break;
                    case 2:
                        filter.push({
                            column: "BoughtDate",
                            value: startTime,
                            condition: "d_greater_than_or_equal",
                        });
                        filter.push({
                            column: "BoughtDate",
                            value: endTime,
                            condition: "d_less_than_or_equal",
                        });
                        break;
                    case 3:
                        filter.push({
                            column: "StoreCNImDate",
                            value: startTime,
                            condition: "d_greater_than_or_equal",
                        });
                        filter.push({
                            column: "StoreCNImDate",
                            value: endTime,
                            condition: "d_less_than_or_equal",
                        });
                        break;
                    case 4:
                        filter.push({
                            column: "StoreCNExDate",
                            value: startTime,
                            condition: "d_greater_than_or_equal",
                        });
                        filter.push({
                            column: "StoreCNExDate",
                            value: endTime,
                            condition: "d_less_than_or_equal",
                        });
                        break;
                    case 5:
                        filter.push({
                            column: "StoreVNImDate",
                            value: startTime,
                            condition: "d_greater_than_or_equal",
                        });
                        filter.push({
                            column: "StoreVNImDate",
                            value: endTime,
                            condition: "d_less_than_or_equal",
                        });
                        break;
                    case 6:
                        filter.push({
                            column: "StoreVNExDate",
                            value: startTime,
                            condition: "d_greater_than_or_equal",
                        });
                        filter.push({
                            column: "StoreVNExDate",
                            value: endTime,
                            condition: "d_less_than_or_equal",
                        });
                        break;
                    case 7:
                        filter.push({
                            column: "PaymentDate",
                            value: startTime,
                            condition: "d_greater_than_or_equal",
                        });
                        filter.push({
                            column: "PaymentDate",
                            value: endTime,
                            condition: "d_less_than_or_equal",
                        });
                        break;
                    case 8:
                        filter.push({
                            column: "CompletedDate",
                            value: startTime,
                            condition: "d_greater_than_or_equal",
                        });
                        filter.push({
                            column: "CompletedDate",
                            value: endTime,
                            condition: "d_less_than_or_equal",
                        });
                        break;
                    default:
                        break;
                }
            }
            return filter;
        },
        openListOrders(csid) {
            this.filterOrder = this.buildFilter(csid, 0);
            this.filterDeposit = this.buildFilter(csid, 1);
            this.dialogDetail = true;
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
<style scoped>
.rate-p {
    margin-bottom: 0px;
    margin-top: 16px;
}
.rate-p2 {
    margin-bottom: 16px;
    margin-top: 8px;
    color: rgb(168, 168, 168);
}
</style>